import {AuthUser} from "../../../context/AuthContext";
import { UserData as UserDataMessage } from "../../../generated/user_pb";

export const buildUserMessage = (user: AuthUser): UserDataMessage => {
    const message = new UserDataMessage();
    message.setUserid(user.userId);
    message.setUsername(user.username);
    message.setToken(user.token);
    return message;
};

